import React from "react";
import { Siren, FilePlus2, UserCog } from "lucide-react";

const TABS = [
  { id: "duty", label: "Duty", Icon: Siren },
  { id: "report", label: "Log", Icon: FilePlus2 },
  { id: "status", label: "Status", Icon: UserCog },
];

const FieldNav = ({ active, onChange, dutyCount = 0 }) => (
  <nav className="fixed bottom-0 left-1/2 z-[1200] w-full max-w-md -translate-x-1/2 border-t border-white/10 bg-[#0A1428]/90 px-3 pb-[max(env(safe-area-inset-bottom),10px)] pt-2 backdrop-blur-xl" style={{ boxShadow: "0 -8px 30px rgba(0,0,0,0.4)" }} data-testid="field-nav">
    <div className="flex items-stretch justify-around">
      {TABS.map(({ id, label, Icon }) => {
        const on = active === id;
        return (
          <button key={id} onClick={() => onChange(id)} className="relative flex flex-1 flex-col items-center gap-1 rounded-2xl py-1.5 transition-transform active:scale-95" data-testid={`field-tab-${id}`}>
            <span className="relative">
              <Icon size={23} strokeWidth={on ? 2.6 : 2} color={on ? "#FFC726" : "#5C6E8C"} />
              {id === "duty" && dutyCount > 0 && <span className="absolute -right-2 -top-1.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-[#FF5C7A] px-1 text-[10px] font-bold text-white">{dutyCount}</span>}
            </span>
            <span className={`text-[11px] font-semibold ${on ? "text-[#FFC726]" : "text-[#5C6E8C]"}`}>{label}</span>
          </button>
        );
      })}
    </div>
  </nav>
);

export default FieldNav;
